module.exports = __WEBPACK_EXTERNAL_MODULE_60__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Observable"
// module id = 60
// module chunks = 0